import { Id } from "PFTypes";

export const configFormKeys = {
  all: (accountId: Id) => ["saas_admin", "account", accountId, "forms"],
  filters: (accountId: Id) => [...configFormKeys.all(accountId), "filters"],
  order: (accountId: Id) => [...configFormKeys.all(accountId), "orderOptions"]
};
